export default __webpack_public_path__ + "static/media/Heart.088c1c0e.svg";